import { render, staticRenderFns } from "./EditCompanyWiseSubscriptionFeeComponent.vue?vue&type=template&id=983d12de&"
import script from "./EditCompanyWiseSubscriptionFeeComponent.vue?vue&type=script&lang=js&"
export * from "./EditCompanyWiseSubscriptionFeeComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports